export type ShadowTokens = {
  none: string;
  xs: string;
  sm: string;
  md: string;
  lg: string;
  xl: string;
  focus: string;
};

export const lightShadows: ShadowTokens = {
  none: 'none',
  xs: '0 1px 2px rgba(15, 23, 42, 0.04)',
  sm: '0 2px 4px rgba(15, 23, 42, 0.05), 0 1px 2px rgba(15, 23, 42, 0.04)',
  md: '0 4px 8px rgba(15, 23, 42, 0.06), 0 2px 4px rgba(15, 23, 42, 0.04)',
  lg: '0 10px 24px rgba(15, 23, 42, 0.08), 0 4px 8px rgba(15, 23, 42, 0.05)',
  xl: '0 24px 48px rgba(15, 23, 42, 0.12), 0 8px 16px rgba(15, 23, 42, 0.06)',
  focus: '0 0 0 3px rgba(234, 88, 12, 0.25)',
};

export const darkShadows: ShadowTokens = {
  none: 'none',
  xs: '0 1px 2px rgba(0, 0, 0, 0.4)',
  sm: '0 2px 4px rgba(0, 0, 0, 0.5), 0 1px 2px rgba(0, 0, 0, 0.4)',
  md: '0 4px 8px rgba(0, 0, 0, 0.55), 0 2px 4px rgba(0, 0, 0, 0.4)',
  lg: '0 10px 24px rgba(0, 0, 0, 0.6), 0 4px 8px rgba(0, 0, 0, 0.45)',
  xl: '0 24px 48px rgba(0, 0, 0, 0.7), 0 8px 16px rgba(0, 0, 0, 0.5)',
  focus: '0 0 0 3px rgba(0, 255, 132, 0.3)',
};
